module.exports = {"id":"182670","name":"Mahmut Tekdemir","rating":"73","photo":"./data/images/photos/2/182670.png","club":{"name":"Medipol Başakşehir","logo":"./data/images/clubs/MedipolBasaksehir.png"},"positions":["MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MahmutTekdemir0.json
// module id = 2659
// module chunks = 0